"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "baselga-di-pine": {
    "3a65080b": [{
      "hkey": "1e55ce9d",
      "slug": "baselga-di-pine",
      "name": "Baselga di Pinè",
      "primary": true,
      "skipSearch": false
    }],
    "ricaldo": [{
      "hkey": "1e55ce9d",
      "slug": "baselga-di-pine",
      "name": "Baselga di Pinè",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7043da81": [{
      "hkey": "17734908",
      "slug": "rizzolaga-campolongo",
      "name": "Rizzolaga-Campolongo",
      "primary": true,
      "skipSearch": false
    }],
    "rizzolaga": [{
      "hkey": "17734908",
      "slug": "rizzolaga-campolongo",
      "name": "Rizzolaga-Campolongo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "cd7d2a44": [{
      "hkey": "26326d88",
      "slug": "sternigo",
      "name": "Sternigo",
      "primary": true,
      "skipSearch": false
    }],
    "ternigo": [{
      "hkey": "26326d88",
      "slug": "sternigo",
      "name": "Sternigo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;